/**
 * Web component: Simple teaser (simple-teaser)
 * -----------------------------------------------------------------------------
 * Simple Teaser.
 *
 */
/* eslint no-unused-vars: ['error', { 'argsIgnorePattern': 'component' }] */
import './simple-teaser.scss';

import { vueReady } from '~/core/runners';
import {
  checkTeaserTimeRemaining,
  handleCopy,
  teaserClosestToEndTime,
  updateTeasers,
} from '~/helpers/teasers';
import * as webComponent from '~/helpers/web-components';
import { isColorDark } from '~/helpers/general';

/**
 * DOM selectors.
 */
const selectors = {
  tooltip: '[js-simple-teaser="tooltip"]',
  fallback: '[js-simple-teaser="fallback"]',
  teaser: '[js-simple-teaser="teaser"]',
  copyButton: '[js-simple-teaser="copyButton"]',
  promoText: '[js-simple-teaser="promoText"]',
  linkBtnContainer: '[js-simple-teaser="linkBtnContainer"]',
};

/**
 * Create new <simple-teaser> custom element.
 */
class SimpleTeaser extends HTMLElement {
  static observedAttributes = ['start-time', 'end-time'];

  attributeChangedCallback(name, oldValue, newValue) {
    webComponent.handleAttributeUpdate(this, name, newValue, oldValue);
  }

  data(component) {
    return {
      selectors: {
        fallback: component.querySelector(selectors.fallback),
        teasers: [...component.querySelectorAll(selectors.teaser)],
        promoTexts: component.querySelectorAll(selectors.promoText),
        copyButtons: component.querySelectorAll(selectors.copyButton),
        linkBtnContainer: component.querySelectorAll(
          selectors.linkBtnContainer,
        ),
      },
    };
  }

  computed(component) {
    return {};
  }

  /**
   * Component lifecycle - before mount.
   */
  constructor() {
    super();
    this.$data = this.data(this);
    this.teasersUpdated = false;

    // for initial load, read campaign state from local storage and update
    // teasers if necessary
    const { copyButtons } = this.$data.selectors;
    if (copyButtons) {
      const discountCampaigns = JSON.parse(
        localStorage.getItem('discount-campaigns'),
      );
      updateTeasers.call(this, discountCampaigns, selectors);

      // listen to campaign changes, update teaser content
      cnvs.EventBus.listen('discount-campaign', (campaigns) => {
        updateTeasers.call(this, campaigns, selectors);
      });
    }
  }

  /**
   * Component lifecycle - mounted.
   */
  connectedCallback() {
    this.$data = Object.keys(this.$data).length ? this.$data : this.data(this);
    webComponent.setup(this);

    if (Shopify.designMode) {
      return;
    }

    const { teasers } = this.$data.selectors;
    const selectedTeaser = teaserClosestToEndTime(teasers, null);

    this.addEventListener('click', (event) =>
      handleCopy(event, selectors.tooltip),
    );

    const linkBtnContainer = this.$data.selectors.linkBtnContainer;

    linkBtnContainer.forEach((container) => {
      const linkBtn = container.querySelector('.simple-teaser__cta');
      const linkBtnbackgroundColor =
        window.getComputedStyle(linkBtn).backgroundColor;

      if (isColorDark(linkBtnbackgroundColor)) {
        linkBtn.classList.remove('accesssibility-focus-invert');
      } else {
        linkBtn.classList.add('accesssibility-focus-invert');
      }
    });

    /**
     * Set interval to check every second if start or end date available
     */
    if (selectedTeaser) {
      setInterval(() => {
        checkTeaserTimeRemaining.call(this, selectedTeaser, selectors);
      }, 1000);
    }
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('simple-teaser')) {
    return;
  }

  customElements.define('simple-teaser', SimpleTeaser);
});
